import dayjs from 'dayjs';

const isEmpty = (value) => value === undefined || value === null || value === '';
const COLLECTION_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const getCollectionStartTimeInitialValue = (value) =>
  !isEmpty(value) && Number.isFinite(Number(value)) ? dayjs(Number(value)) : undefined;

const formatCollectionLastCompletedAt = (value) => {
  if (isEmpty(value) || !Number.isFinite(Number(value))) {
    return '-';
  }
  return dayjs(Number(value)).format(COLLECTION_DATE_TIME_FORMAT);
};

const serializeCollectionStartTime = (value) => {
  if (isEmpty(value)) {
    throw new Error('请选择正确的采集起始时间');
  }
  const timestamp = dayjs(value).valueOf();
  if (!Number.isFinite(timestamp)) {
    throw new Error('请选择正确的采集起始时间');
  }
  return Math.floor(timestamp / 1000) * 1000;
};

export {
  formatCollectionLastCompletedAt,
  getCollectionStartTimeInitialValue,
  serializeCollectionStartTime,
};
